<script lang="ts" setup>
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "vue-chartjs";
import { ref, computed, watch } from "vue";
import ChartInnerTextPlugin from "./plugins/chartInnerTextPlugin";

const props = defineProps({
  percentage: {
    type: Number,
    default: undefined,
  },
  color: {
    type: String,
    default: "#00A2DF",
  },
  styles: {
    type: Object,
  },
});

const chartData = ref({
  datasets: [
    {
      data: [0, 0], // Default data
      backgroundColor: [props.color, "#F1F5F6"], // Use color from props
      borderColor: "#FFFFFF",
      borderWidth: 2,
      color: "#fff",
    },
  ],
});

const chartOptions = computed(() => ({
  responsive: false,
  maintainAspectRatio: true,
  deep: false,
  cutout: "50%",
  animation: {
    duration: 2000,
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
    chartInnerTextPlugin: {
      chartInnerTextPlugin: {
        percentage: true,
      },
    },
  },
}));

watch(
  () => props.percentage,
  (newPercentage) => {
    if (newPercentage !== undefined) {
      chartData.value.datasets[0].data = [newPercentage, 100 - newPercentage];
      chartData.value = {
        ...chartData.value,
        datasets: [...chartData.value.datasets],
      };
    }
  },
  { immediate: true } // This ensures the watcher runs immediately on initialization
);

ChartJS.register(ArcElement, Tooltip, Legend);
</script>

<template>
  <Doughnut key="Donut" :data="chartData" :options="chartOptions" :style="styles" :plugins="[ChartInnerTextPlugin]" />
</template>
